<div class="flex flex-col max-w-[383px] sm:max-w-[474px] pt-[46px] sm:pt-[56px] pb-[42px] sm:pb-[55px]
 rounded-[33px] sm:rounded-[50px] bg-opacity-30 bg-beige relative">
  <div class="w-full text-center justify-center text-cafe text-2xl font-semibold font-['Roboto'] tracking-wide">{{'buttons.contactUs' | transloco}}</div>
<div class="flex flex-col pl-[19px] pt-[30px] sm:pl-[56px] pr-[19px]  sm:pr-[73px]">

  <form [formGroup]="form" class="flex flex-col space-y-4">
    <!-- Nombre -->
    <div class="flex flex-col">
      <label for="name" class="text-verde text-sm font-normal pb-[6px]">{{'forms.placeholders.fullName' | transloco}}</label>
      <input
        id="name"
        type="text"
        formControlName="name"
        [placeholder]="'forms.placeholders.fullNameExample' | transloco"
        [ngClass]="[form.get('name')?.invalid && form.get('name')?.touched ? 'border-red-500' : '', 'w-full h-[48px] border border-cafe focus:outline-verde rounded-md p-2' ]" />
      @if(form.get('name')?.touched && form.get('name')?.invalid) {
        <div class="mt-1 text-sm text-red-600">
          @if(form.get('name')?.errors?.['required']) {
            <div>{{'labels.requiredField' | transloco}}.</div>
          }
          @if(form.get('name')?.errors?.['minlength']) {
            <div>{{'messages.minFullNameLength' | transloco}}.</div>
          }

        </div>
      }
    </div>

    <!-- Teléfono -->
    <div class="flex flex-col">
      <label class="text-verde text-sm font-normal mb-[6px]" for="phone">{{'labels.phone' | transloco}}</label>
      <div class="flex items-start gap-4">
        <!-- Bandera y código país -->
        <input
          #phoneInput
          formControlName="phonePrefix"
          type="tel"
          (keydown)="preventTyping($event)"
          class="hide-number-arrow hide-phone-input ng-pristine w-full h-[48px] border rounded-md border-cafe focus:outline-verde p-2" />

        <!-- Número de teléfono -->
        <div class="flex flex-col">
          <input
            type="number"
            formControlName="phoneNumber"
            [placeholder]="'forms.placeholders.phoneExample' | transloco"
            [ngClass]= "[form.get('phoneNumber')?.invalid && form.get('phoneNumber')?.touched ? 'border-red-500' : '','hide-number-arrow ng-pristine w-full h-[48px] border border-cafe focus:outline-verde rounded-md p-2' ]"
          />
          @if (form.get('phoneNumber')?.touched && form.get('phoneNumber')?.invalid) {
            <div class="mt-1 text-sm text-red-600">{{'labels.requiredField' | transloco}}.</div>
          }
        </div>
      </div>
    </div>

    <!-- Correo -->
    <div class="flex flex-col">
      <label class="text-verde text-sm font-normal mb-[6px]" for="email">{{'labels.email' | transloco}}</label>
      <input
        id="email"
        type="email"
        formControlName="email"
        [placeholder]="'forms.placeholders.emailExample' | transloco"
        [ngClass]= "[form.get('email')?.invalid && form.get('email')?.touched ? 'border-red-500': '', 'w-full h-[48px] border border-cafe focus:outline-verde rounded-md px-4 py-2']"
           />
      @if(form.get('email')?.touched && form.get('email')?.invalid) {
        <div class="mt-1 text-sm text-red-600">
          @if(form.get('email')?.errors?.['required']) {
            <div>{{'labels.requiredField' | transloco}}.</div>
          }
          @if (form.get('email')?.invalid) {
            <div>{{'messages.validEmail' | transloco}}.</div>
          }
        </div>

      }
    </div>
<!--    elija una opcion-->
    <div class="flex flex-col">
      <label class="text-verde text-sm font-normal mb-[6px]" for="email">{{'labels.selectAContactOption' | transloco}}</label>
      <ln-contact-page-form-drop-down
        id="contactOption"
        [attr.aria-invalid]="showContactOptionError()"
        [attr.aria-describedby]="showContactOptionError() ? 'contactOption-error' : null"
        formControlName="contactOption" [showContactOptionError]="showContactOptionError" [listOfOptions]="listOfOptions"></ln-contact-page-form-drop-down>
          @if(showContactOptionError()) {
            <div class="mt-1 text-sm text-red-600">{{'labels.requiredField' | transloco}}.</div>
          }
    </div>
    <!-- Mensaje -->
    <div class="flex flex-col">
      <label class="text-verde text-sm font-normal mb-[6px]" for="message">{{'labels.optionalMessage' | transloco}}</label>
      <textarea
        rows="4"
        formControlName="message"
        maxlength="250"
        class="w-full rounded-md border border-cafe focus:outline-verde px-4 py-2"></textarea>
      <div class="mt-1 flex items-start justify-between text-xs text-cafe">
        <p>{{'labels.provideADetailedContactDescription' | transloco}}.</p>
        <p class="text-verde text-xs font-normal">{{ contadorCaracteresMessage }}/250</p>
      </div>
    </div>

    <!-- Enviarme una copia -->
    <div class="flex items-center gap-2">
      <input id="copy" type="checkbox" formControlName="sendCopy" class="accent-verde cursor-pointer h-[18px] w-[18px]" />
      <label class="text-sm font-medium text-cafe" for="copy" >{{'labels.sendMeACopy' | transloco}}</label>
    </div>

    <!-- Botón -->
    <div>
      <ln-primary-button
        type="button"
        [class]="'flex w-full h-[48px] justify-center rounded-md bg-[#577778] items-center text-white text-base font-semibold transition hover:bg-[#305447]'"
        [label]="'buttons.send' | transloco"
        (OnClick)="onSubmit()"
        [showSpinner]="enviarButtonShowLoading()"></ln-primary-button>
    </div>
<!--    cloudfire captcha-->
    <ln-captcha [captchaToken]="captchaToken"></ln-captcha>
  </form>
</div>
  @if (showSuccessfulModal()) {
    <ln-full-screen-modal [present]="showSuccessfulModal">
      <ln-successful-order-card [close]="showSuccessfulModal()" (closePressed)="closeSuccessfulModal()"
                                [tittle]="'messages.successfullyContactRequest' | transloco"
                                [textBody]="'messages.successfulOrder' | transloco" body
                                ></ln-successful-order-card>
    </ln-full-screen-modal>
  }
</div>
